export const FEEDBACK_CATEGORIES = [
  { value: 'ai_recognition_names', label: 'AI recognition of people names' },
  { value: 'ai_recognition_places', label: 'AI recognition of place names' },
  { value: 'accent', label: 'Accent recognition' },
  { value: 'language_detection', label: 'Language detection' },
  {
    value: 'conversation_summary',
    label: 'Accurately summarizing the conversation',
  },
  {
    value: 'keyword_identification',
    label: 'Accurate identification of keywords',
  },
  { value: 'other', label: 'Other' },
];

export const FORM_VALIDATION = {
  MAX_TEXT_LENGTH: 1000,
  REQUIRED_CATEGORY_MESSAGE: 'Please select a feedback category',
} as const;

export const UI_TEXT = {
  MODAL_TITLE: 'Feedback on HARMONY AI',
  MODAL_SUBTITLE: 'Help us improve transcript accuracy and AI features',
  CATEGORY_LABEL: 'What was the issue with the transcript?',
  CATEGORY_PLACEHOLDER: 'Select an issue category...',
  FREEFORM_LABEL: 'Describe your issue and share your thoughts...',
  FREEFORM_PLACEHOLDER:
    'Please provide any additional details about the issue...',
  SHARE_DETAILS_TITLE: 'Share call details with this feedback',
  SHARE_DETAILS_DESCRIPTION:
    'Include transcription text, summary, keywords, detected language, caller information, and other technical details to help our team improve HARMONY AI.',
  SUCCESS_MESSAGE:
    'Feedback submitted successfully! Thank you for helping us improve HARMONY AI.',
  ERROR_MESSAGE: 'Failed to submit feedback. Please try again.',
  CANCEL_BUTTON: 'Cancel',
  SUBMIT_BUTTON: 'Send Feedback',
} as const;
